import {Navigate, NonIndexRouteObject} from "react-router"
import {ScaApp} from "../components/app/ScaApp";
import {ErrorPage} from "../components/page";
import {
    navigationStore,
    pageQueryStore,
    scaCreateStore,
    scaCustomerStore,
    scaDetailStore,
    scaOverviewStore,
    validationStore
} from "../store";
import {AcquisitionStatusDto} from "../api/sca";
import React from "react";


const sca: NonIndexRouteObject[] = [
    {
        path: `/sca`,
        element: <ScaApp mode={'overview'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({request}) => {
            await scaCustomerStore.init()
            const searchParams = new URL(request.url).searchParams
            pageQueryStore.updateSystem('sca', searchParams)

            scaOverviewStore.page = parseInt(searchParams.get("page") || "") || 1
            scaOverviewStore.size = parseInt(searchParams.get("size") || "") || 25

            scaOverviewStore.query = searchParams.get('q') || undefined
            scaOverviewStore.fromRelative = searchParams.get('fromRelative') || undefined
            scaOverviewStore.toRelative = searchParams.get('toRelative') || undefined
            scaOverviewStore.fromAbsolute = searchParams.get('fromAbsolute') || undefined
            scaOverviewStore.toAbsolute = searchParams.get('toAbsolute') || undefined
            scaOverviewStore.customerId = searchParams.get('customerId') || undefined
            scaOverviewStore.status = searchParams.getAll('status') as AcquisitionStatusDto[] || undefined

            scaOverviewStore.load().finally()
            navigationStore.setActivePath(request)
            return null
        }
    },
    {
        path: `/sca/create`,
        element: <ScaApp mode={'create'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({request}) => {
            validationStore.reset()
            scaCreateStore.reset()
            await scaCustomerStore.init()
            navigationStore.setActivePath(request)
            return null
        }
    },
    {
        path: `/sca/:id`,
        element: <ScaApp mode={'detail'}/>,
        errorElement: <Navigate to={`/sca`} replace={true}/>,
        loader: async ({params, request}) => {
            validationStore.reset()
            scaDetailStore.id = params.id!!
            await scaCustomerStore.init()
            const result = await scaDetailStore.load()
            if (!result) {
                throw Error
            }
            navigationStore.setActivePath(request)
            return null
        }
    },
]

export {
    sca
}
